var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00011 4.00002H4.00011V1.00002H1.00011V4.00002ZM4.41843e-05 1.00006C1.44455e-05 0.44775 0.44775 1.31585e-05 1.00006 1.87971e-05C2.00001 2.90058e-05 2.99997 1.63731e-05 3.99992 7.13516e-06C4.55224 2.03266e-06 4.99997 0.447764 4.99992 1.00008L4.9997 4.00009C4.99966 4.55235 4.55195 5.00002 3.9997 5.00002H1.00016C0.447812 5.00002 7.37229e-05 4.5522 0.000106316 3.99986C0.00016532 2.99992 9.80255e-05 1.99999 4.41843e-05 1.00006Z",
    fill: "#A8B3C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00011 11H4.00011V8.00002H1.00011V11ZM4.41843e-05 8.00006C1.44455e-05 7.44775 0.44775 7.00001 1.00006 7.00002C2.00001 7.00003 2.99997 7.00002 3.99992 7.00001C4.55224 7 4.99997 7.44776 4.99992 8.00008L4.9997 11.0001C4.99966 11.5523 4.55195 12 3.9997 12H1.00016C0.447812 12 7.37229e-05 11.5522 0.000106316 10.9999C0.00016532 9.99992 9.80255e-05 8.99999 4.41843e-05 8.00006Z",
    fill: "#A8B3C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60828 8.00002C6.27234 8.00002 6 8.27235 6 8.60829C6 8.94424 6.27234 9.21657 6.60828 9.21657H11.3917C11.7277 9.21657 12 8.94424 12 8.60829C12 8.27235 11.7277 8.00002 11.3917 8.00002H6.60828Z",
    fill: "#A8B3C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60191 1.00002C6.26948 1.00002 6 1.2695 6 1.60192C6 1.93435 6.26948 2.20383 6.60191 2.20383H11.3981C11.7305 2.20383 12 1.93435 12 1.60192C12 1.2695 11.7305 1.00002 11.3981 1.00002H6.60191Z",
    fill: "#A8B3C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57643 3.00002C6.25808 3.00002 6 3.25809 6 3.57645C6 3.8948 6.25808 4.15288 6.57643 4.15288H9.92357C10.2419 4.15288 10.5 3.8948 10.5 3.57645C10.5 3.25809 10.2419 3.00002 9.92357 3.00002H6.57643Z",
    fill: "#A8B3C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60191 10C6.26948 10 6 10.2695 6 10.6019C6 10.9344 6.26948 11.2038 6.60191 11.2038H9.89809C10.2305 11.2038 10.5 10.9344 10.5 10.6019C10.5 10.2695 10.2305 10 9.89809 10H6.60191Z",
    fill: "#A8B3C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxes);
export default __webpack_public_path__ + "static/media/checkboxes.45e83f6ca79088fbeea2f7d949d06e25.svg";
export { ForwardRef as ReactComponent };